import { Fragment, memo } from "react";
import { BzCard } from "../../components";
import { Col, Row } from "react-bootstrap";
import { _handleTimeDifference } from "../../controllers";
import { handleModal, handleModalData } from "../../redux/actions/modals";
import { useDispatch } from "react-redux";



const NewsHoldingCards = ({ arrHolding, id }) => {

    const dispatch = useDispatch();

    const date = _handleTimeDifference(arrHolding?.Date?.split(" ")[0], arrHolding?.Time);


    const handleDetails = (arrHolding) => {
        dispatch(handleModal([{ "HOT_PURSUIT_DATA": true }], true));
        dispatch(handleModalData({ newsData: arrHolding, newstype: "hotPursuit" }));

    };



    return (
        <Fragment key={id}>
            <BzCard key={arrHolding?.id} className='hotnews-card d-flex flex-column justify-content-center me-2 mb-2' onClick={() => handleDetails(arrHolding)}>
                <Row className='g-0 mb-2'>
                    <Col className='d-flex justify-content-end'>
                        <div className='icon-16 icon-portfolio icon-dark'></div>
                    </Col>
                </Row>
                <Row className='g-0 pb-2'>
                    <Col className='hotnews-title'>
                        <div className='font-medium font-size3 color-text news-title-truncate'>{arrHolding?.Heading}</div>
                    </Col>
                </Row>
                <Row className='g-0 pb-3'>
                    <Col className='hotnews-info'>
                        <div className='font-regular font-size2 color-text news-truncate' dangerouslySetInnerHTML={{ __html: arrHolding?.ArtText }}></div>
                    </Col>
                </Row>
                <Row className='g-0 mb-1'>
                    <Col className='d-flex justify-content-start'>
                        <div className='font-regular font-size1 color-text'>{date}</div>
                    </Col>
                </Row>
            </BzCard>
        </Fragment>
    );
};

export default memo(NewsHoldingCards);